import { CustomerModel, AuctionModel } from "./";

export class InvoiceModel {
    Id: number;
    CustomerId: number;
    AuctionId: number;
    Firstname: string;
    Surname: string;
    Address1: string;
    Address2: string;
    Address3: string;
    Suburb: string;
    State: string;
    Postcode: number;
    DeliveryAddress1: string;
    DeliveryAddress2: string;
    DeliveryAddress3: string;
    DeliverySuburb: string;
    DeliveryState: string;
    DeliveryPostcode: number;
    Phone: string;
    Fax: string;
    Notes: string;
    Paid: boolean;
    Tax: boolean;
    Tag: boolean;
    Handling: number;
    Freight: number;
    Insurance: number;
    BuyerPremium: number;
    OriginalId: number;
    DateCreated: Date;
    DateModified: Date;
    IsDeleted: boolean;
    Customer: CustomerModel;
    Auction: AuctionModel;
    InvoiceNumber: string;
    RequiresDelivery: boolean = false;

    constructor() {

    }
}